'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var handler = HANDLERS[action.type] || function () {
        return state;
    };
    return handler(action.payload, state);
};

var _WixInstalledAppsActions = require('../actions/WixInstalledAppsActions');

var WixInstalledAppsActions = _interopRequireWildcard(_WixInstalledAppsActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    apps: null,
    success: false
}; // Reducer that holds which of Wix Restaurants apps are installed in the
// site

var HANDLERS = (0, _defineProperty3.default)({}, WixInstalledAppsActions.types.GET_INSTALLED_APPS_SUCCESS, function (payload, state) {
    return (0, _extends3.default)({}, state, {
        apps: payload.apps,
        success: payload.success
    });
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/reducers/WixInstalledAppsReducer.js
// module id = 856
// module chunks = 0